// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const skrelp: PokeData = {
  "id": 690,
  "name": "skrelp",
  "height": 5,
  "weight": 73,
  "base_experience": 64,
  "types": [
    PokeType.POISON,
    PokeType.WATER
  ],
  "api_moves": [
    "tackle",
    "tail-whip",
    "acid",
    "water-gun",
    "hydro-pump",
    "toxic",
    "double-team",
    "smokescreen",
    "bubble",
    "feint-attack",
    "sludge-bomb",
    "camouflage",
    "poison-tail",
    "water-pulse",
    "aqua-tail",
    "dragon-pulse"
  ],
  "moves": [
    "tackle",
    "acid",
    "hydro-pump",
    "bubble",
    "sludge-bomb",
    "aqua-tail",
    "dragon-pulse",
    "aqua-cutter",
    "acid-rain",
    "whirlpool",
    "toxic-spikes",
    "water-spout",
    "aqua-jet"
  ],
  "evolution_chain": {
    "id": 354,
    "item": null,
    "species": [
      {
        "name": "skrelp",
        "order": 691,
        "types": [
          PokeType.POISON,
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "dragalge",
        "order": 692,
        "types": [
          PokeType.POISON,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": 690,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 48,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 55,
    "speed": 30,
    "ability_power": 60
  },
  "stat_changes": [],
  "catch_rate": 225,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
